import { Dialog } from "material-ui";

/**
 * Mobile safari doesn't seem to respect scrolling very well.  So we're going to create
 * a new scrolling dialog just for safari that updates the body position so that
 * it won't scroll.
 */
class MobileScrollingDialog extends Dialog {
    componentWillReceiveProps(nextProps) {
        if (super.componentWillReceiveProps) {
            super.componentWillReceiveProps(...arguments);
        }
        if (this.props.open !== nextProps.open) {
            if (nextProps.open) {
                this.onRendered();
            } else {
                this.onUnrendered();
            }
        }
    }

    componentWillUnmount() {
        this.onUnrendered();
    }

    onRendered = () => {
        const { body } = document;
        if (body) {
            body.style.overflow = "hidden";
            body.style.position = "fixed";
            body.style.height = "100%";
        }
    };

    onUnrendered = () => {
        const { body } = document;
        if (body) {
            delete body.style.overflow;
            body.style.position = "relative";
            delete body.style.height;
        }
    };
}

const ua = window.navigator.userAgent;
const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
const webkit = !!ua.match(/WebKit/i);
const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

export default (iOSSafari ? MobileScrollingDialog : Dialog);



// WEBPACK FOOTER //
// ./src/components/MobileScrollingDialog.jsx